import {TemplateList} from "~/libs/constants/TemplateList"
import {useTemplate} from "~/composables/useTemplate"
import {SeoConfig} from "~/config/SeoConfig"
import type SeoMeta from "~/libs/interfaces/SeoMeta"

export const useSeoWrapper = () => {
  /**
   * get default SEO config for template
   */
  const getSeoConfig = ():SeoMeta => {
    return useTemplate().getTemplateListItem() !== null ? SeoConfig[useTemplate().getTemplateListItem() as TemplateList] : {}
  }

  /**
   * set SEO meta
   * @param input
   * @param options
   */
  const setSeoMeta = (input: any = {}, options?: any) => {
    const seoConfig = getSeoConfig()
    const url = useRequestURL()

    const defaultSeoInput = {
      title: null, // Default title is handled by module NuxtSeo - this is title add
      author: seoConfig.author,
      description: seoConfig.description,
      ogImage: seoConfig.image,
      twitterCard: seoConfig.twitterCard,
      twitterDomain: url.hostname,
      twitterUrl: url.href,
      twitterTitle: seoConfig.title,
      ogTitle: seoConfig.ogTitle,
      ogDescription: seoConfig.ogDescription,
      // themeColor: seoConfig.themeColor,
    }

    // merge DEFAULT with PAGE RELATED seo
    const newMeta = {
      ...defaultSeoInput,
      ...input
    }

    // SET missing Facebook, Twitter or other meta
    if (!newMeta.ogTitle && newMeta.title) {
      newMeta.ogTitle = newMeta.title
    }
    if (!newMeta.ogDescription && newMeta.description) {
      newMeta.ogDescription = newMeta.description
    }
    if (!newMeta.twitterDescription && newMeta.description) {
      newMeta.twitterDescription = newMeta.description
    }
    if (newMeta.title) {
      newMeta.twitterTitle = `${newMeta.twitterTitle} - ${newMeta.title}`
    }
    if (!newMeta.twitterImage && newMeta.ogImage) {
      newMeta.twitterImage = newMeta.ogImage
    }

    useSeoMeta(
      newMeta,
      options
    )
  }

  return {
    getSeoConfig,
    setSeoMeta,
  }
}


